import type { KbLane } from "@/lib/kb/types";

export type GuidancePurpose = "contacts" | "policy" | "advice" | "pricing";
export type GuidanceProduct = "all" | "sheds" | "steel";
export type GuidanceSource = "user_selected" | "auto_rules" | "default";
export type GuidanceSnapshot = {
  lane: KbLane;
  purpose: GuidancePurpose;
  product: GuidanceProduct;
  source: GuidanceSource;
};

export function laneToPurpose(lane: KbLane): GuidancePurpose {
  if (lane === "contacts") return "contacts";
  if (lane === "pricing") return "pricing";
  return "policy";
}

export function classifyPurposeFromQuery(query: string): GuidancePurpose {
  const q = query.toLowerCase();
  if (
    /(who\s+(do|should|can)\s+(i|we)\s+(talk|call|contact|ask|reach)|who\s+handles|who\s+to\s+(contact|ask|call)|contact|owner|escalat|support person)/i.test(
      q
    )
  )
    return "contacts";
  if (/(price|pricing|cost|msrp|quote|\$\d+|how much)/i.test(q)) return "pricing";
  if (/(how should|best way|advice|recommend|tips|coach|improve)/i.test(q)) return "advice";
  return "policy";
}

export function classifyProductFromQuery(query: string): GuidanceProduct {
  const q = query.toLowerCase();
  if (/(steel|metal structure|carport|metal building)/i.test(q)) return "steel";
  if (/(shed|barn|utility|cabin|lofted)/i.test(q)) return "sheds";
  return "all";
}

export function isThreadNotFoundError(err: unknown): boolean {
  const msg = err instanceof Error ? err.message : String(err || "");
  return /thread not found/i.test(msg);
}

/** Pill label: combines fulfillment path (KB vs directory) with the user-selected Training Ask lane. */
export function trainingAskResultBadgeLabel(
  answerMode: "kb" | "contacts" | "location",
  lane: KbLane | null | undefined
): string {
  if (answerMode === "location") return "Location lookup";
  if (answerMode === "contacts") return "Contacts lookup";
  if (lane === "pricing") return "KB answer · pricing lane";
  if (lane === "contacts") return "KB answer · contacts lane";
  return "KB answer";
}
